export default {
  cancel: 'cancel',
  close: 'close',
  new_version: {
    message: 'A new version is available.',
    reload: 'Update',
  },
  cta: {
    inactive: {
      title: 'Free trial period expired',
      admin: {
        body: 'The free trial period is now ended. You need to subscribe in order to enjoy VerticalTopo.',
        button: 'subscribe',
      },
      user: {
        body: 'The free trial period is now ended. Please contact an administrator of this spot to subscribe in order to enjoy VerticalTopo.',
        button: 'pricing',
      },
    },
    trial: {
      title_zero: 'Free trial period will expire soon',
      title_one: 'Free trial period expires soon',
      title_other: 'Free trial period expires in {{count}} days',
      admin: {
        body: 'Please subscribe to remove this message and enjoy VerticalTopo.',
        button: 'subscribe',
      },
      user: {
        body: 'Please contact an administrator of this spot to subscribe in order to enjoy VerticalTopo',
        button: 'pricing',
      },
      pricing: 'Show pricing and plans',
    },
    demo: {
      title: 'You are in a "demo" spot',
      body: 'You have access to the administration settings, but you cannot change anything.',
      button: 'create a spot',
    },
    upgrade: {
      title: {
        subscribe: 'Subscribe to a plan',
        upgrade: 'Upgrade your plan',
      },
      body: {
        item: {
          stats: 'statistics',
          comment: 'comments',
          route: 'routes',
          lane: 'lanes',
          color: 'colors',
          membership: 'members',
          sector: 'sectors',
          spot: 'spots',
        },
        plan: {
          none: '4C',
          small: '4C',
          medium: '6A',
          large: '7B',
        },
        why: {
          adding_subscribe: "You've reached the maximum number of {{ item }} included in the free trial plan.",
          adding_upgrade: "You've reached the maximum number of {{ item }} included in your plan.",
          subscribe: 'This feature requires a subscription to the {{plan}} plan or higher.',
          upgrade: 'This feature is available from the {{plan}} plan.',
          unavailable: 'This feature is not availalble.',
        },
        what: {
          support: 'Contact us for a customized plan.',
          admin_said: 'Go to the Billing menu to subscribe to this plan.',
          admin_subscribe: 'Go to the Billing menu to subscribe to an plan.',
          admin_upgrade: 'Go to the Billing menu to subscribe to an higher plan.',
          user: 'Contact an administrator of your spot to manage the subscription.',
        },
      },
      button: {
        user: 'tarifs',
        admin: 'souscrire',
        support: 'contacter',
      },
      support: {
        body: 'Contactez le support pour une offre sur mesure',
      },
      admin: {
        body: 'Souscrivez à une offre supérieure pour accéder à cette fonctionnalité',
      },
      user: {
        body: 'Contactez un administrateur du site afin de souscire à une offre supérieure et accéder à cette fonctionnalité.',
      },
    },
  },
  pwa: {
    cta: {
      title: 'Install the app',
      body: 'Get better experience with the application',
      not_available:
        "We cannot install the app on your device. Perhaps you've already installed it?\n" +
        'If not, try opening the page with another browser.',
      already_installed: 'The app is already installed on your device.',
      inprogress_install: 'The app is currently being installed. This may take a few minutes.',
      resume: 'Go home',
      button: 'Install',
      dismiss: 'Dismiss',
    },
    notification: {
      accepted: 'Installation in progress',
      canceled: 'Installation canceled',
    },
    button: 'Install',
    buttonLong: 'Install the app',
  },
  menu: {
    global: {
      stared: 'Stared spots',
      search: 'Find a spot',
      dashboard: 'Dashboard',
      workout: 'Workout',
    },
    locale: 'change locale',
    spot: {
      topo_routes: "Spot's topo",
      admin_main: 'Administration',
      admin_comments: 'Comments',
      admin_stats: 'Stats',
      admin_routes: 'Route settings',
      admin_settings: {
        title: 'Settings',
        global: 'Global',
        colors: 'Colors',
        sectors: 'Sectors',
        lanes: 'Lanes',
        memberships: 'Permissions',
        spots: 'Spots',
        billing: 'Billing',
      },
      star: 'Star spot',
      unstar: 'Unstar spot',
      unstar_admin: 'You are an admin',
    },
  },
  table: {
    rows: '{{from}}–{{to}} on {{count}}',
  },
  tooltip: {
    hard: 'hard version',
    easy: 'easy version',
  },
  prompt: {
    body: 'You have unsaved changes, are you sure you want to leave?',
    proceed: 'Leave this page',
    reset: 'Stay on this page',
  },
}
